// Formats the page data into the following format:
// { after: <startCursor>, first: <numberOfItems> }
// This is to help with pagination in our GraphQL api
export const formatPageData = (pageNumber, itemsPerPage) => {
  const startCursor = btoa(itemsPerPage * (pageNumber - 1));

  return { after: startCursor, first: itemsPerPage };
};
